module.exports = __webpack_public_path__ + "h5/img/promoter.5de0605f.png";